<template>
    <div class="page magic-bg dark:text-white">
        <navigation :key="navigationKey"/>
        <div class="bookmark">
            <div class="bookmark-container">
                <div class="bookmark-modal" id="user_list_adjustments">
                    <div class="flex flex-row items-center justify-between mb-2">
                        <p class="bookmark-modal-title text-gradient mr-auto">Сортировка</p>
                        <button class="rounded-button" title="Очистить сортировку" @click="ClearParams">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 hover:animate-spin" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                    <div class="form-group ml-2 mt-2">
                        <label class="w-28">Поиск</label>
                        <input class="input sm:ml-2" type="text" v-model="search_param">
                    </div>
                    <div class="form-group ml-2 mt-2">
                        <label class="w-28 break-words">Статус</label>
                        <select class="input sm:ml-2" v-model="status_param">
                            <option value="">Все</option>
                            <option value="false">Открыт</option>
                            <option value="true">Закрыт</option>
                        </select>
                    </div>
                    <p class="bookmark-modal-title text-gradient mr-auto">Инструменты</p>
                    <button class="mt-2 ml-2 mr-auto" @click="pageNumber = 0;_ProccessCourses()">Запросить данные заново</button>
                    <button class="mt-2 ml-2 mr-auto" @click="$root.ShowModal('#NewCourse')" v-if="$root.HasRole($store.state.methodistRole) || $root.HasRole($store.state.adminRole)">Создать новый курс</button>
                </div>
            </div>
            <div class="bookmark-navbar">
                <div class="bookmark-link" @click="$root.ToggleBookmark('#user_list_adjustments')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z" />
                    </svg>
                </div>
            </div>
        </div>
        <div class="flex flex-row items-end justify-between mt-4 w-[90%] max-w-5xl mx-auto fade">
            <div class="flex flex-row items-center justify-center background rounded-t-lg ml-3 py-2 px-3 fade">
                <p>С</p>
                <p class="ml-2">{{pageNumber * elementNumber + 1}}</p>
                <p class="ml-2">по</p>
                <p class="ml-2">{{pageNumber * elementNumber + courses.length}}</p>
                <p class="ml-2"><b class="text-gradient">Всего:</b> {{courseCount}}</p>
            </div>
            <div class="flex flex-row items-center justify-center background rounded-t-lg mr-3 py-2 px-3 fade">
                <button @click="Back">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
                    </svg>
                </button>
                <p>{{pageNumber + 1}}</p>
                <p class="ml-2">из</p>
                <p class="ml-2">{{pagesCount}}</p>
                <button @click="Forward">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
        </div>
        <div class="card py-0 w-[90%] max-w-5xl mx-auto overflow-auto fade" style="max-height: calc(100vh - 10rem)">
            <table class="sys-table mb-2">
                <thead>
                    <th>№</th>
                    <th v-if="$root.HasRole($store.state.adminRole)">ID</th>
                    <th>Название</th>
                    <th>Тип</th>
                    <th>Кол-во ак. часов</th>
                    <th>Цена</th>
                    <th>Статус</th>
                    <th></th>
                    <th></th>
                </thead>
                <tbody>
                    <tr v-for="(course, index) in courses" :key="index">
                        <th>{{pageNumber * elementNumber + index + 1}}</th>
                        <td class="text-center" v-if="$root.HasRole($store.state.adminRole)">{{course.ID}}</td>
                        <td class="text-center">{{course.Title}}</td>
                        <td class="text-center">{{course.Type}}</td>
                        <td class="text-center">{{course.VolumeHours}}</td>
                        <td class="text-center">
                            <div class="flex flex-col">
                                <span>{{course.Price}}</span>
                                <div class="flex flex-col font-bold text-info" v-if="course.StudentPrice != ''">
                                    <span>студентам</span>
                                    <span>{{ course.StudentPrice }}</span>
                                </div>
                            </div>
                        </td>
                        <td class="text-center">
                            <span class="font-bold text-danger" v-if="course.Closed">Закрыт</span>
                            <span class="font-bold text-success" v-else>Открыт</span>
                        </td>
                        <th>
                            <button class="text-blue-600" @click="SeeCourse(course.ID)">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                </svg>
                            </button>
                        </th>
                        <th>
                            <button class="text-red-600" @click="DeleteCourse(course.ID)">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </th>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="modal dark:text-white" id="SeeCourse" @click="$root.HideModal('#SeeCourse')" v-if="currentCourse">
        <div class="modal-dialog max-w-5xl" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Просмотр данных курса</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#SeeCourse')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="flex flex-wrap gap-5">
                    <div class="flex flex-col border w-max max-w-[20rem]">
                        <div class="w-[20rem] h-[20rem] background-darker relative">
                            <img class="w-full h-full object-cover" :src="currentCourse.FilePath">
                        </div>
                        <div class="flex flex-col p-3">
                            <span class="font-bold text-2xl">{{ currentCourse.Title }}</span>
                            <span class="text-neutral-500 mt-2 whitespace-pre-wrap">{{ currentCourse.Description }}</span>
                        </div>
                    </div>
                    <div class="flex flex-col">
                        <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                            <p class="subtitle">Тип</p>
                            <p>{{currentCourse.Type}}</p>
                        </div>
                        <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                            <p class="subtitle">Кол-во ак. часов</p>
                            <p>{{currentCourse.VolumeHours}}</p>
                        </div>
                        <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                            <p class="subtitle">Цена</p>
                            <div class="flex items-center gap-1">
                                <span>{{currentCourse.Price}}</span>
                                <div class="flex items-center gap-1 font-bold text-info" v-if="currentCourse.StudentPrice != ''">
                                    <span>студентам</span>
                                    <span>{{ currentCourse.StudentPrice }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                            <p class="subtitle">Статус</p>
                            <span class="font-bold text-danger" v-if="currentCourse.Closed">Закрыт</span>
                            <span class="font-bold text-success" v-else>Открыт</span>
                        </div>
                        <p class="text-center font-bold text-2xl">Заявки</p>
                        <div class="overflow-auto max-h-[400px]">
                            <table class="sys-table">
                                <thead>
                                    <th>ФИО</th>
                                    <th>Email</th>
                                    <th>Номер телефона</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(participant, idx) in currentCourse.Participants" :key="idx">
                                        <td class="text-center">
                                            {{ participant.surname }} {{ participant.name }} {{ participant.middle_name }}
                                        </td>
                                        <td class="text-center">
                                            {{ participant.email }}
                                        </td>
                                        <td class="text-center">
                                            {{ participant.number_phone }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#SeeCourse');$root.ShowModal('#ChangeCourse')">Изменить</button>
            </div>
        </div>
    </div>

    <div class="modal dark:text-white" id="NewCourse" @click="$root.HideModal('#NewCourse')" v-if="$root.HasRole($store.state.methodistRole) || $root.HasRole($store.state.adminRole)">
        <form class="modal-dialog" @submit="NewCourse" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Новый курс</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#NewCourse')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Название <b class="text-red-600">*</b></label>
                    <input type="text" class="input sm:ml-auto min-w-[300px]" ref="new_course_title">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Кол-во ак. часов <b class="text-red-600">*</b></label>
                    <input type="text" class="input sm:ml-auto min-w-[300px]" ref="new_course_volume_hours">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Тип <b class="text-red-600">*</b></label>
                    <div class="flex flex-row items-center justify-between sm:ml-auto min-w-[300px] input">
                        <input type="text" class="input max-w-[250px] p-0" ref="new_course_type">
                        <select class="w-4 bg-transparent p-0" @change="(e) => this.$refs.new_course_type.value = e.target.value">
                            <option value="">Очистить</option>
                            <option v-for="ct in course_types" :value="ct">{{ ct }}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Цена <b class="text-red-600">*</b></label>
                    <input type="text" class="input sm:ml-auto" ref="new_course_price">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Цена для студентов</label>
                    <input type="text" class="input sm:ml-auto" ref="new_course_student_price">
                </div>
                <div class="flex flex-col gap-2 w-full my-2">
                    <label class="input-label">Описание <b class="text-red-600">*</b></label>
                    <textarea class="input min-w-[300px] max-w-none" rows="10" ref="new_course_description"></textarea>
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#NewCourse')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#NewCourse')">Добавить</button>
            </div>
        </form>
    </div>

    <div class="modal dark:text-white" id="ChangeCourse" @click="$root.HideModal('#ChangeCourse');$root.ShowModal('#SeeCourse')" v-if="($root.HasRole($store.state.methodistRole) || $root.HasRole($store.state.adminRole)) && currentCourse">
        <form class="modal-dialog" @submit="ChangeCourse" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Изменение данных курса</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#ChangeCourse');$root.ShowModal('#SeeCourse')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Название <b class="text-red-600">*</b></label>
                    <input type="text" class="input sm:ml-auto min-w-[300px]" ref="current_course_title" :value="currentCourse.Title">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Кол-во ак. часов <b class="text-red-600">*</b></label>
                    <input type="text" class="input sm:ml-auto min-w-[300px]" ref="current_course_volume_hours" :value="currentCourse.VolumeHours">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Тип <b class="text-red-600">*</b></label>
                    <div class="flex flex-row items-center justify-between sm:ml-auto min-w-[300px] input">
                        <input type="text" class="input max-w-[250px] p-0" ref="current_course_type" :value="currentCourse.Type">
                        <select class="w-4 bg-transparent p-0" @change="(e) => this.$refs.current_course_type.value = e.target.value">
                            <option value="">Очистить</option>
                            <option v-for="ct in course_types" :value="ct">{{ ct }}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Цена <b class="text-red-600">*</b></label>
                    <input type="text" class="input sm:ml-auto" ref="current_course_price" :value="currentCourse.Price">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Цена для студентов</label>
                    <input type="text" class="input sm:ml-auto" ref="current_course_student_price" :value="currentCourse.StudentPrice">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Закрыт</label>
                    <input type="checkbox" class="checkbox-toggle sm:ml-auto" ref="current_course_closed" :checked="currentCourse.Closed">
                </div>
                <div  class="form-group w-full my-2">
                    <label class="input-label">Файл</label> 
                    <file-input class="sm:ml-auto" :filename="currentCourse.FileName" id="cf" ref="cf" />
                </div>
                <div class="flex flex-col gap-2 w-full my-2">
                    <label class="input-label">Описание <b class="text-red-600">*</b></label>
                    <textarea class="input min-w-[300px] max-w-none" rows="10" ref="current_course_description" :value="currentCourse.Description"></textarea>
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeCourse');$root.ShowModal('#SeeCourse')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeCourse')">Изменить</button>
            </div>
        </form>
    </div>
</template>

<script>
import Navigation from '@/components/Navigation'
import FileInput from '@/components/FileInput'

export default {
    components: {
        Navigation,
        FileInput
    },
    data() {
        return {
            search_param: "",
            status_param: "",
            course_types: [],
            courses: [],
            courseCount: 0,
            elementNumber: 25,
            pageNumber: 0,
            pagesCount: 0,
            currentCourse: null,
            navigationKey: "nav",
            title: "Список курсов"
        }
    },
    methods: {
        SetTitle() {
            document.title = `Samgk DPO - ${this.title}`
        },
        Forward() {
            this.pageNumber = this.pageNumber >= this.pagesCount - 1 ? 0 : this.pageNumber + 1
            this._ProccessCourses()
        },
        Back() {
            this.pageNumber = this.pageNumber <= 0 ? this.pagesCount - 1 : this.pageNumber - 1
            this._ProccessCourses()
        },
        ClearParams() {
            this.search_param = ""
            this.status_param = ""
        },
        async _SelectData() {
            let res = await fetch(this.$store.state.aeApiAddr + "/v1.0/courses/types", {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
            }).then(response => {return response.json()})
            .catch(error => {
                this.$root.Fatal()
            })

            this.course_types = res.data.types
        },
        async _ProccessCourses() {
            this.$root.StartLoading()

            var res = await fetch(this.$store.state.aeApiAddr + `/v1.0/courses/list?limit=${this.elementNumber}&skip=${this.pageNumber * this.elementNumber}&search=${this.search_param}&is_closed=${this.status_param}`, {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
            }).then(response => {return response.json()})
            .catch(error => {
                this.$root.Fatal()
            })

            if (this.$root.HandleFetchError(res)) return

            this.courseCount = res.data.collections

            this.pagesCount = Math.ceil(this.courseCount / this.elementNumber)

            let courses = []

            for (var i in res.data.courses) {
                var course = res.data.courses[i]

                courses.push({
                    ID: course.id,
                    Title: course.title,
                    Type: course.type,
                    Description: course.description,
                    VolumeHours: course.volume_of_hours,
                    Price: course.price,
                    StudentPrice: course.price_for_students ?? "",
                    Closed: course.is_closed ?? false,
                    FileName: course.file_name,
                })
            }

            this.courses = courses

            this.$root.EndLoading()
        },
        async SeeCourse(id) {
            var res = await fetch(this.$store.state.aeApiAddr + `/v1.0/courses/by_id/${id}`, {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
            }).then(response => { return response.json() })
            .catch(error => {
                this.$root.Fatal()
            })

            if (this.$root.HandleFetchError(res)) return

            if (res["error"] === undefined) {
                const course = res["data"]["course"]
                this.currentCourse = {
                    ID: course.id,
                    Title: course.title,
                    Type: course.type,
                    Description: course.description,
                    VolumeHours: course.volume_of_hours,
                    Price: course.price,
                    StudentPrice: course.price_for_students ?? "",
                    Closed: course.is_closed ?? false,
                    FileName: course.file_name,
                    FilePath: "",
                    Participants: course.participants,
                }

                // file
                {
                    var resp = await fetch(this.$store.state.filesApiAddr + `/v1.0/ae/courses/by_id/${id}`, {
                        method: "GET",
                        headers: {
                            'Authorization': `Bearer ${this.$root.GetToken()}`,
                        },
                    })
                    .catch(error => {
                        this.$root.Fatal()
                    })

                    if (resp && resp.status === 200) {

                        const file = await new Promise(async (resolve, _) => {
                            const reader = new FileReader()
                            reader.onloadend = () => resolve(reader.result)
                            reader.readAsDataURL(await resp.blob())
                        })

                        this.currentCourse.FilePath = file
                    }
                }

                setTimeout(() => this.$root.ShowModal("#SeeCourse"))
            }
        },
        NewCourse(e) {
            e.preventDefault()

            let title = this.$refs.new_course_title.value
            let type = this.$refs.new_course_type.value
            let description = this.$refs.new_course_description.value
            let volume_hours = this.$refs.new_course_volume_hours.value
            let price = this.$refs.new_course_price.value
            let student_price = this.$refs.new_course_student_price.value

            fetch(this.$store.state.aeApiAddr + "/v1.0/courses/", {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    title: title,
                    type: type,
                    description: description,
                    volume_of_hours: volume_hours,
                    price: price,
                    price_for_students: student_price,
                    is_closed: false,
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Курс успешно добавлен", "success")
                this._ProccessCourses()
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        ChangeCourse(e) {
            e.preventDefault()

            let title = this.$refs.current_course_title.value
            let type = this.$refs.current_course_type.value
            let description = this.$refs.current_course_description.value
            let volume_hours = this.$refs.current_course_volume_hours.value
            let price = this.$refs.current_course_price.value
            let student_price = this.$refs.current_course_student_price.value
            let is_closed = this.$refs.current_course_closed.checked

            if (this.$refs.cf.IsChanged()) {
                let file_data = this.$refs.cf.GetFileData()
                if (file_data.length > 0) {

                    let data = new FormData()

                    data.append("file", file_data[0])

                    data.append("id", this.currentCourse.ID)

                    fetch(this.$store.state.filesApiAddr + "/v1.0/ae/courses/", {
                        method: "POST",
                        headers: {
                            'Authorization': `Bearer ${this.$root.GetToken()}`,
                        },
                        body: data
                    })
                    .then(response => response.json())
                    .then(res => {
                        if (this.$root.HandleFetchError(res)) return
                        this.$root.ShowToast("Файл курса успешно изменён", "success")
                        this.$refs.cf.ResetIsChanged()
                        this._ProccessCourses()
                    })
                    .catch(error => {
                        this.$root.Fatal()
                    })
                } else {
                    if (this.currentCourse.FileName !== null && this.currentCourse.FileName.trim() !== "") {
                        fetch(this.$store.state.filesApiAddr + "/v1.0/ae/courses/", {
                            method: "DELETE",
                            headers: {
                                'Authorization': `Bearer ${this.$root.GetToken()}`,
                                'Content-Type': 'text/json;charset=utf-8'
                            },
                            body: JSON.stringify({id: this.currentCourse.ID})
                        })
                        .then(response => response.json())
                        .then(res => {
                            if (this.$root.HandleFetchError(res)) return
                            this.$root.ShowToast("Файл курса успешно удалён", "success")
                            this.$refs.cf.ResetIsChanged()
                            this._ProccessCourses()
                        })
                        .catch(error => {
                            this.$root.Fatal()
                        })
                    }
                }
            }

            fetch(this.$store.state.aeApiAddr + "/v1.0/courses/", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.currentCourse.ID,
                    title: title,
                    type: type,
                    description: description,
                    volume_of_hours: volume_hours,
                    price: price,
                    price_for_students: student_price,
                    is_closed: is_closed,
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Данные курса успешно изменены", "success")
                this._ProccessCourses()
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        DeleteCourse(id) {
            fetch(this.$store.state.aeApiAddr + "/v1.0/courses/", {
                method: "DELETE",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({ id: id })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Курс успешно удалён", "success")
                this._ProccessCourses()
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
    },
    mounted() {
        if (this.$root.fatal) return
        this.SetTitle()
        this.$root.StartLoading()
        this.$root.UpdateToken()
        this.$root.GetRoles().then(()=>{
            if (!(this.$root.HasRole(this.$store.state.adminRole) || this.$root.HasRole(this.$store.state.methodistRole))) {
                this.$root.ShowToast("У вас нет прав на посещение данного раздела", "error", 8000)
                this.$router.push({name: 'Home'})
                return
            }
            this._ProccessCourses().then(()=>{
                this.$root.EndLoading()
            })
            this._SelectData()
        })   
    }
}
</script>